export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/DxfViewerWorker.fdd8f63a.worker.js");
}
